import featureToggles from 'shared/featureToggles'
import { isAddressFilled, invoicePriceFormatter } from 'shared/utils'
import { CardSectionButton } from 'shared/components/CardSectionButton'
import { CardSection } from '@components/CardSection'
import Icon from '@components/Icon'

import MessageBox, { MSG_WARNING } from '@components/MessageBox'
import { DELIVERY_COLLECT, DELIVERY_HOME } from 'purchase-flow/constants'

import styles from '../styles.module.scss'

const PhysicalAccessOption = ({
    accessOptionProducts,
    showForm,
    selectDeliveryRate,
    selectedDeliveryRate,
    selectRate,
    setShowForm,
    isRateSelected,
    deliveryAddress,
    isActiveAccessCard,
    setIsActiveAccessCard,
    shouldRenderProductsWithRates,
    translate: t,
}) => {
    const shouldShowAddressForm = prd =>
        Boolean(!showForm && prd?.currentPrd?.prdctCd === DELIVERY_HOME && !isAddressFilled(deliveryAddress))

    const onCardButtonClick = (rate, isWaitList) => {
        selectRate(rate, isWaitList)
        selectDeliveryRate(rate)

        if (setShowForm) {
            setShowForm(shouldShowAddressForm)
        }
        setIsActiveAccessCard(true)
    }

    return (
        <CardSection activeSelected={isActiveAccessCard} notActive className="px-3 py-3 mt-3">
            <div className="d-sm-flex justify-content-between align-items-start">
                <div>
                    <div className="font-weight-bold text-large">
                        <T>subscription.purchase.accessOptions.access.card.label</T>
                    </div>
                    <div className="text-light">
                        <T>subscription.purchase.accessOptions.access.card.desc</T>
                    </div>
                </div>
            </div>
            <>
                <div className={styles.accessOptionsRates}>
                    {accessOptionProducts.map(product => {
                        const isWaitList = Boolean(product.waitListId)

                        if (shouldRenderProductsWithRates) {
                            if (product.prdctCd === DELIVERY_HOME && product.ratePlans.length === 0) {
                                return null
                            }

                            return product.ratePlans.map((rate, i) => (
                                <CardSectionButton
                                    key={i}
                                    onClick={() => onCardButtonClick(rate, isWaitList)}
                                    value={invoicePriceFormatter(rate.price)}
                                    description={
                                        <span className="font-weight-bold">
                                            {rate.name || t('Subscription.purchase.accessoptions.collect.option.label')}
                                        </span>
                                    }
                                    isSelected={isRateSelected(rate)}
                                    className={styles.rateButton}
                                    extraDesc={product?.prdctExtraLongDesc || product.prdctLongDesc}
                                    isCapitalizeCase
                                />
                            ))
                        }
                    })}
                </div>
                {selectedDeliveryRate && selectedDeliveryRate?.currentPrd?.prdctCd === DELIVERY_HOME && (
                    <MessageBox type={MSG_WARNING} className={styles.messageBox}>
                        <T>subscription.purchase.mail.info</T>
                        {featureToggles.brNeoPurchaseFlow && (
                            <a
                                className="font-weight-bold"
                                href={`mailto: ${withTranslate('subscription.purchase.main.address')}`}>
                                <T>subscription.purchase.main.address</T>
                            </a>
                        )}
                    </MessageBox>
                )}
            </>
            {selectedDeliveryRate && shouldShowAddressForm(selectedDeliveryRate) && (
                <div className="text-red mt-3 text-small align-items-center d-flex">
                    <span className="mr-1">
                        <Icon type="warning-triangle" />
                    </span>
                    <T>booking.monthly.missing-address-error</T>
                </div>
            )}
        </CardSection>
    )
}

export default withTranslate(PhysicalAccessOption)
